export const menuList = [
  {
    name: "Franchisee Details",
    icon: "business",
  },
  {
    name: "Category",
    icon: "category",
  },
  {
    name: "Service List",
    icon: "list",
  },
  {
    name: "Technician details",
    icon: "person",
  },

  {
    name: "Job Add",
    icon: "task",
  },
  {
    name: "Booking details",
    icon: "pages",
  },
  {
    name: "Payment details",
    icon: "list",
  },
];
